module.exports = __webpack_public_path__ + "static/img/2.9397225.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/zh/2.png
// module id = 7rC0
// module chunks = 0